import { IndicatifEntity } from "../../indicatif-tel/indicatif.entity";

import { NatureInterventionEntity } from "./nature-intervention.entity";

export class EntrepriseExterieureEntity {
    idEntrepriseExt!: number;
    nomEntreprise!: string;
    raisonSociale!: string;
    natureInterventions!: NatureInterventionEntity[];
    nomRepresentant!: string;
    fonctionRepresentant!: string;
    telephoneRepresentant!: string;
    emailRepresentant!: string;
    effectifMoyen!: number;
    indicatifRepresentant!: IndicatifEntity | null;
    indicatifIdRepresentant: number = 1;

    constructor() {
    }
}